
import { OrderSideEnum } from '../../enum/orders/side.enum';
import { InstrumentLite } from '../quote/instrument-lite.model';
import { UtilitiesService } from '../../services/utilities.service';
import { OrderMarketTypeEnum } from '../../enum/orders/market-type.enum';
import { RecommendationCategory } from './research-category.model';
import { ResearchCategoryID } from '../../enum/research-category-id.enum';

export class ResearchAdviceLite {

    /**
     * Gerar um mock de Research
     * @param {string} symbol Código do ativo
     * @param {number} id ID da recomendação
     * @param {OrderSideEnum} side Side da recomendações.
     * @param {boolean} daytrade Se a recomendação.
     * @param {boolean} avaliable Se está disponível ou não.
     * @param {OrderMarketTypeEnum} typeMarket Tipo de mercado da recomendação.
     */
    public static getMock(
        symbol: string,
        id: number,
        side: OrderSideEnum,
        daytrade: boolean,
        avaliable: boolean,
        typeMarket: OrderMarketTypeEnum): ResearchAdviceLite {

        return {
            id,
            symbolID: symbol,
            side,
            isDayTrade: daytrade,
            avaliable,
            goal: 1,
            stop: 1,
            details: ``,
            duration:  '1 hora',
            instrument: InstrumentLite.getMock(symbol, 7 , typeMarket),
            category: {
                description: '',
                id: ResearchCategoryID.ShortTerm + 1,
                name: 'Top',
                order: 2,
                recommendations: [],
                url: '',
                infoproduct: false,
            },
        };
    }

    public id: number;
    public symbolID: string;
    public side: OrderSideEnum;
    public isDayTrade: boolean;
    public avaliable: boolean;
    public goal: number;
    public stop: number;
    public details: string;
    public duration: string;
    public instrument: InstrumentLite;
    public category: RecommendationCategory;

    constructor(response) {
        this.id = response.id;
        this.symbolID = response.symbolID;
        this.side = response.side;
        this.isDayTrade = response.isDayTrade;
        this.avaliable = response.avaliable;
        this.goal = response.goal;
        this.stop = response.stop;
        this.details = response.details;
        this.duration = response.duration;
        this.instrument = response.instrument ? new InstrumentLite(response.instrument) : null;
        this.category = response.category;
    }
}
